import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import messages from '../../text/messages';
import { getViceVersaFullName } from '../../utilities/string';
import { dateToFloatingString } from '../../utilities/dateTime';
import Table from '../../components/table';
import { getPayDueDetails } from '../../reducers/users';

import '../invoice/invoice.css';

class PayDuePage extends React.Component {
    componentDidMount() {
        const { match, getPayDueDetails } = this.props;
        getPayDueDetails(match.params.payDueId);
    }

    getColumnDefinition() {
        return [
            {
                label: <FormattedMessage {...messages.type} />,
                valueMap: d => <div className="full-height-cell ellipsis ">{d.type}</div>,
                size: 'col-sm-2 col-xs-4',
                sort: (a, b) => a.type.localeCompare(b.type)
            },
            {
                label: <FormattedMessage {...messages.description} />,
                valueMap: d => <div className="full-height-cell ellipsis">{d.description}</div>,
                size: 'col-sm-4 hidden-xs',
                sort: (a, b) => a.description.localeCompare(b.description)
            },

            {
                label: <FormattedMessage {...messages.hours} />,
                valueMap: d => <div className="full-height-cell ellipsis ">{isNaN(d.hours) ? '' : d.hours.toFixed(2)}</div>,
                size: 'col-sm-2 col-xs-4',
                sort: (a, b) => (a.hours || 0) - (b.hours || 0)
            },
            {
                label: <FormattedMessage {...messages.rate} />,
                valueMap: d => <div className="full-height-cell ">{d.bill_rate ? d.bill_rate.toFixed(2) : ''}</div>,
                size: 'col-sm-2 hidden-xs',
                sort: (a, b) => (a.bill_rate || 0) - (b.bill_rate || 0)
            },
            {
                label: <FormattedMessage {...messages.amount} />,
                valueMap: d => <div className="full-height-cell">{(d.extended || 0).toFixed(2)}</div>,
                size: 'col-sm-2 col-xs-4',
                sort: (a, b) => (a.extended || 0) - (b.extended || 0)
            }
        ];
    }
    render() {
        const { payDue } = this.props;

        if (!payDue) {
            return null;
        }

        const { name, date, total, currency, items } = payDue;
        const decoratedItems = items.map(i => ({ ...i, description: i.description || `Period ending ${moment(i.period_ending).format('YYYY-MM-DD')}` }));
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4 className="bold">{name}</h4>
                    </div>
                    <hr />
                </div>
                <hr />

                <div className="row">
                    <div className="col-sm-3 col-xs-12">
                        <div className="invoiceValues">{getViceVersaFullName(items[0] || {})}</div>
                        <div className="invoiceLabels">
                            <FormattedMessage {...messages.name} />
                        </div>
                    </div>
                    <div className="col-sm-2 col-xs-6">
                        <div className="invoiceValues">{total.toFixed(2)}</div>
                        <div className="invoiceLabels">
                            <FormattedMessage {...messages.total} />
                        </div>
                    </div>
                    <div className="col-sm-1 col-xs-6">
                        <div className="invoiceValues"> {currency} </div>
                        <div className="invoiceLabels">
                            <FormattedMessage {...messages.currency} />
                        </div>
                    </div>
                    <div className="col-sm-2  col-xs-6">
                        <div className="invoiceValues"> {dateToFloatingString(date, 'YYYY-MM-DD')}</div>
                        <div className="invoiceLabels">
                            <FormattedMessage {...messages.date} />
                        </div>
                    </div>
                    <div className="col-sm-2  col-xs-6">
                        <div className="invoiceValues"> {items.length}</div>
                        <div className="invoiceLabels">
                            <FormattedMessage {...messages.records} />
                        </div>
                    </div>
                </div>
                <hr />

                <div className="row topOffset15">
                    <div className="col-xs-12  topOffset15">
                        <Table data={decoratedItems} columns={this.getColumnDefinition()} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12">
                        <hr />
                        <hr />
                        <div className="invoiceTotal">
                            <FormattedMessage {...messages.total} /> <h4> {total.toFixed(2)} </h4>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

PayDuePage.meta = {
    hide: true,
    locations: ['/paydue/']
};

const mapStateToProps = state => {
    return {
        payDue: state.users.paydue
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getPayDueDetails
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PayDuePage);



// WEBPACK FOOTER //
// ./src/pages/payDue/index.jsx